import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { convertArrayBuffer } from 'helpers/imageHelper';
import { useMedia } from 'hooks/useMedia';

import ContentItem from 'components/common/InfoPopup/ContentItem';
import StarsRateComponent from 'components/common/StarsRateComponent';
import VerifiedBadge from 'components/common/VerifiedBadge';
import { MAX_RATE_COUNT } from 'constants/settings';

import styles from './styles.module.scss';

const HeaderContainer = ({
    items,
    companyLogo,
    companyName,
    companyId,
    isVerified,
    children,
    paymentStatusSummary,
    ratings,
    showChatButton,
    onChatClick,
}) => {
    const { t } = useTranslation();
    const { isDesktop } = useMedia();
    const isMobile = !isDesktop;

    return (
        <div className={styles.header}>
            <div className={styles.header__top}>
                <img
                    src={
                        companyLogo
                            ? convertArrayBuffer(companyLogo)
                            : new URL('img/person-chat.svg', import.meta.url).href
                    }
                    className={styles.header__logo}
                    alt={t('companyLogotype')}
                />
                <div className={styles.header__content}>
                    <div className={styles.header__title}>
                        <div className={styles.header__nameRating}>
                            <div className={styles.header__nameWithBadge}>
                                {companyId ? (
                                    <Link to={`/company/${companyId}`} className={styles.header__companyName}>
                                        {companyName}
                                    </Link>
                                ) : (
                                    <span className={styles.header__companyName}>{companyName}</span>
                                )}
                                <VerifiedBadge isVerified={isVerified} size="small" />
                            </div>
                            {ratings && (
                                <div className={styles.header__ratings_container}>
                                    <StarsRateComponent
                                        value={ratings.rate || 0}
                                        maxRate={MAX_RATE_COUNT}
                                        className={styles.header__rate}
                                    />
                                </div>
                            )}
                        </div>
                        {showChatButton && (
                            <button className={styles.header__chatButton} type="button" onClick={onChatClick}>
                                {t('transport.to_chat')}
                            </button>
                        )}
                    </div>
                    {isDesktop && paymentStatusSummary}
                    {isDesktop && items && items.length > 0 && (
                        <ul className={styles.header__list}>
                            {items.map(
                                (item, index) =>
                                    item.value && <ContentItem key={index} isHeader {...item} withoutMargin />,
                            )}
                        </ul>
                    )}
                </div>
            </div>
            {isMobile && paymentStatusSummary && (
                <div className={styles.header__mobilePaymentStatus}>{paymentStatusSummary}</div>
            )}
            {isMobile && items && items.length > 0 && (
                <ul className={styles.header__list}>
                    {items.map(
                        (item, index) => item.value && <ContentItem key={index} isHeader {...item} withoutMargin />,
                    )}
                </ul>
            )}
            {showChatButton && (
                <button className={styles.header__chatButtonMobile} type="button" onClick={onChatClick}>
                    {t('transport.to_chat')}
                </button>
            )}
            {children}
        </div>
    );
};

HeaderContainer.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            value: PropTypes.string,
        }),
    ),
    companyLogo: PropTypes.any,
    companyName: PropTypes.string,
    companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isVerified: PropTypes.bool,
    children: PropTypes.node,
    paymentStatusSummary: PropTypes.node,
    ratings: PropTypes.shape({ rate: PropTypes.number }),
    showChatButton: PropTypes.bool,
    onChatClick: PropTypes.func,
};

export default HeaderContainer;
